import { lazy } from "react";

const Findash = lazy(() => import("./Findash"));

const findashRoutes = [
  {
    path: "/findash",
    component: Findash,
  },
];

export default findashRoutes;
